import React from 'react'
import PropTypes from 'prop-types'

import { Grid, Typography } from '@material-ui/core'

import useMobileBreakpoint from 'artkive/hooks/useMobileBreakpoint'

import { CARD_IMAGE_RATIO, MOBILE_IMAGE_RATIO } from './Keepsakes.constants'
import Phrases from './Phrases'
import { Body, Feature, FeatureGrid, Features, Photo, PhotoWrapper, Section, Title } from './ProductFeatures.style'

const ProductFeatures = ({ title, features, children, ...rest }) => {
  const isMobile = useMobileBreakpoint()

  return (
    <Section title={title} {...rest}>
      <Features>
        {children}
        <FeatureGrid container spacing={isMobile ? 0 : 5}>
          {features.map(({ title: featureTitle, titleWidth, mobileTitleWidth, body, image, alt }, index) => (
            <Grid xs={12} md={4} item key={featureTitle}>
              <Feature last={index === features.length - 1}>
                <PhotoWrapper>
                  <Photo ratio={isMobile ? MOBILE_IMAGE_RATIO : CARD_IMAGE_RATIO} src={image} alt={alt} />
                </PhotoWrapper>
                <Title variant='h3' titleWidth={titleWidth} mobileTitleWidth={mobileTitleWidth}>
                  <Phrases text={featureTitle} />
                </Title>
                <Body>
                  <Typography variant='body1'>{body}</Typography>
                </Body>
              </Feature>
            </Grid>
          ))}
        </FeatureGrid>
      </Features>
    </Section>
  )
}

ProductFeatures.propTypes = {
  title: PropTypes.node.isRequired,
  features: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      titleWidth: PropTypes.number,
      mobileTitleWidth: PropTypes.number,
      body: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      alt: PropTypes.string.isRequired,
    }),
  ).isRequired,
  children: PropTypes.node,
}

export default ProductFeatures
